var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"collection_point"}},[_c('router-link',{staticClass:"btn--pill blue",attrs:{"to":"/students/intern","id":"intern_btn"}},[_vm._v("\n      實習業務\n    ")])],1),_vm._v(" "),_c('student-profile-form',{attrs:{"lock-student-id":"","current-student":_vm.currentStudentGetter},on:{"submit":_vm.submitProfile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }